<template>
  <div class="col-md-12 card shadow border">
    <div class="spinner-cover" v-if="is_loading">
      <div class="spinner"></div>
    </div>
    <div class="row justify-content-center">
      <div id="tickettabs" class="col-md-9 p-0">
        <photos-modal/>
        <form v-on:submit.prevent="createTask" autocomplete="off">
          <div class="innerdoc">
            <div class="docuvtabs pl-2">
              <ul class="nav nav-tabs" id="myTab" role="tablist">
                <li class="nav-item">
                  <a class="nav-link active" data-toggle="tab" href="#dtab1" role="tab" aria-controls="dtab1" aria-selected="false">
                    <img src="@/assets/images/tab-icon-12.png" alt="icon">
                  </a>
                </li>

                <li class="nav-item">
                  <a class="nav-link" data-toggle="tab" href="#dtab2" role="tab" aria-controls="dtab2" aria-selected="true">
                    <img src="@/assets/images/tab-icon-5.png" alt="icon">
                  </a>
                </li>

                <li class="nav-item">
                  <a class="nav-link" data-toggle="tab" href="#dtab3" role="tab" aria-controls="dtab3" aria-selected="false" id="btnPlanTab">
                    <img src="@/assets/images/tab-icon-6.png" alt="icon">
                  </a>
                </li>

                <!--              <li class="nav-item">-->
                <!--                <a class="nav-link" data-toggle="tab" href="#dtab6" role="tab" aria-controls="dtab6"-->
                <!--                   aria-selected="false"> <img src="@/assets/images/tab-icon-15.png" alt="icon"></a>-->
                <!--              </li>-->
              </ul>
              <div class="tab-content pt-3 cscroll screen-height create-height">
                <div class="text-black tab-pane active pb-4 pr-3" id="dtab1" role="tabpanel">
                  <div class="row pb-1">
                    <div class="col-md-7 f1 pb-4 text-black" id="task-params-create">
                      <div class="heading mb-2">
                        <h5 class="text-black">
                          <strong>Daten</strong>
                        </h5>
                      </div>
                      <div class="form-group mt-2 pt-1">
                        <label class="font1rem font-weight-bold mb-1" for="title">Titel</label>
                        <input type="text" class="form-control" v-model="task.flawname" id="title">
                      </div>
                      <div class="form-group">
                        <label for="des" class="font1rem font-weight-bold">Beschreibung</label>
                        <textarea class="form-control" rows="7" v-model="task.description" id="des"></textarea>
                      </div>
                      <div class="col-md-12 pl-0">
                        <label class="font1rem font-weight-bold">Zusatzfelder</label>
                      </div>
                      <div class="form-group mb-1 pt-1 pb-1" v-for="(param , index) in task.flawparams" :key="index">
                        <div class="row m-0 params-div">
                          <div class="col-md-5 pl-0">
                            <input @change="checkDuplicates" class="form-control input-style" v-model="param.paramtitle" :disabled="param.isNew !== 'yes'" placeholder="Feldname">
                          </div>
                          <div class="col-md-7 pl-0">
                            <input class="form-control input-style" v-model="param.paramvalue">
                          </div>
                          <img src="@/assets/images/delete_icon.png" alt="delete" width="20" class="delete-img" title="Remove" @click="removeFlawParam(index)">
                        </div>
                      </div>
                      <button class="btn btn-light" type="button" @click="addNewFlawParam">
                        <i class="fa fa-plus pr-1"></i> Neues Zusatzfeld
                      </button>
                    </div>
                    <div class="col-md-5 pr-1  border-left text-black border-dark f2">
                      <div class="tblock mb-2">
                        <select class="form-control font13 border-danger col-md-9" v-model="task.status">
                          <option :value="0">Erledigt</option>
                          <option :value="1">Prüfen</option>
                          <option :value="2">Offen</option>
                        </select>
                      </div>
                      <div class="tblock pt-2">
                        <label class="font-weight-bold font1rem mb-1">Art</label>
                        <select class="form-control font13" v-model="task.flawtype">
                          <option :value="1">Mangel</option>
                          <option :value="2">Restleistung</option>
                        </select>
                      </div>

                      <div class="tblock pt-1 scroll-services card border pl-2 shadow-sm">
                        <h5 class="font-weight-bold mb-1">Gewerk </h5>
                        <ul class="list-group-flush">
                          <li v-for="(service , index) in services" :key="index" class="list-group-item pt-2 pb-1 pl-0 pr-0">
                            <div class="btns">
                              <input type="checkbox" class="w-auto service-checkbox" :value="{ pdserviceid: `${service.pdserviceid}-${service.projectuserserviceid}` , title: ''}" :id="'serv'+index" v-model="selectedTrades">
                              <label class="d-inline pl-1" :for="'serv'+index">
                                {{service.pdservicetitle}}
                                <span v-if="service.company">
                                  ( {{ service.company }} )
                                </span>
                              </label>
                            </div>
                          </li>
                        </ul>
                      </div>

                      <div class="tblock user pt-3">
                        <h5 class="mb-2 font-weight-bold">Verantwortlicher</h5>
                        <div class="row mt-2 mb-2 mr-0">
                          <div class="col-sm-3  text-black pr-0 text-center">
                            <img src="@/assets/images/user.png" class="img-fluid w-75 rounded-circle" alt="userIng">
                          </div>
                          <div class="col-sm-9 pr-0 pl-1 pt-2">
                            <select class="form-control font13 pl-2" v-model="task.responsibleuser">
                              <option v-for="user in projectUsers" :value="user.pduserid">
                                {{user.firstname}} {{user.lastname}}
                              </option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div class="tblock text-black">
                        <h5 class="font-weight-bold">Festgestellt am</h5>
                        <input class="datepicker form-control font13 mt-2" :value="noticeDate(task.noticedate)" data-date-format="dd.mm.yyyy" id="notice">
                      </div>
                      <div class="tblock text-black mb-2">
                        <h5 class="font-weight-bold">Angezeigt am</h5>
                        <input class="datepicker form-control font13 mt-2" :value="setDate(task.notifiedate)" name="created" data-date-format="dd.mm.yyyy" id="notifi">
                      </div>
                      <div class="tblock text-black mb-2">
                        <h5 class="font-weight-bold">Frist</h5>
                        <input class="datepicker form-control font13 mt-2" :value="setDate(task.fristdate)" data-date-format="dd.mm.yyyy" name="nodate" id="frist">
                      </div>
                      <div class="tblock text-black">
                        <h5 class="font-weight-bold">Erledigt am</h5>
                        <input class="datepicker done-date form-control font13 mt-2" :value="setDate(task.donedate)" name="nodate" data-date-format="dd.mm.yyyy" id="done">
                      </div>

                      <div class="tblock  text-black user">
                        <h5 class="font-weight-bold">Ersteller</h5>
                        <div class="row mt-2 mb-2 mr-0">
                          <div class="col-sm-3  text-black pr-0 text-center">
                            <img src="@/assets/images/user.png" class="img-fluid w-75 rounded-circle" alt="userIng">
                          </div>
                          <div class="col-sm-9 pr-0 pl-1">
                            <p class="m-0 pt-3 font13">{{authUser.firstname}} {{authUser.lastname}}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="tab-pane pb-5" id="dtab2" role="tabpanel">
                  <h4>Fotos</h4>
                  <div class="picswrap pb-3" v-if="photos.length > 0">
                    <div class="cpics border-top">
                      <div class="form-row ml-0 mr-0 mt-2">
                        <div class="col col-md-3 pl-1" v-for="(photo ,i) in photos" :key="i">
                          <div class="simple-photo m-0">
                            <div  @click="removePhoto(i)" class="position-absolute remove-img">
                              <img src="@/assets/images/delete_icon.png" data-value="btn" alt="remove" class="img-fluid"   title="Löschen" style="width: 20px">
                            </div>
                            <Popup :photo="photo" />
                            <div  data-aspect-ratio="4:3" class="img-fluid">
                              <div :style="{'background-image': 'url(\'' + photo.src + '\')'}"></div>
                            </div>
                            <div class="simple-photo-option">
                              <ul>
                                <li>Nr.{{photo.runid}}</li>
                                <li>|</li>
                                <li>{{photo.photodate | date}}  </li>
                                <li>|</li>
                                <li> {{ photo.photodate.substr(11,5) }} Uhr</li>
                              </ul>
                            </div>
                          </div>
                          <div class="card p-1 font13">
                            <p>
                              <strong class="font13">Beschreibung :</strong>
                            </p>
                            <textarea v-model="photo.description" v-on:input="autoGrow($event.target)" class="p-1 form-control form-control-sm"></textarea>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="clearfix"></div>
                  <div class="col-12" :class="{ 'pt-3 border-top': photos.length === 0 }">
                    <button class="btn btn-light font1rem p-2 rounded mt-1" type="button"  data-toggle="modal" data-target="#tasks-photos_Modal" style="z-index: 9999">
                      Fotos hinzufügen
                    </button>
                  </div>
                </div>

                <!--  Plan Canvas Tab   -->
                <CreateTaskCanvas/>

                <!--            History Tab-->
                <!--              <div class="tab-pane" id="dtab6" role="tabpanel">-->
                <!--                <history-tab/>-->
                <!--              </div>-->
                <div class="doku-btns-sticky pt-1">
                  <span class="btninner">
                    <button type="reset" @click="$store.commit('refreshNewTaskDetails'); $router.push({name:'tasksList', params: {id: $route.params.id}})" class="btn btn-danger">
                      Abbrechen
                    </button>
                    <button type="submit" class="btn btn-primary">
                      Speichern
                    </button>
                  </span>
                </div>
              </div>
            </div>
            <div class="clearfix"></div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import {mapState} from 'vuex'
import {formatAsInputDate, formatDate} from '../common'
import Popup from '../photo/components/infoPopup'
import PhotosModal from './PhotosModal'
import TasksFilterNav from './TasksFilterNav'
import CreateTaskCanvas from './CreateTaskCanvas'
export default {
  props: ['taskPhotosParams'],
  data() {
    return {
      sideBar: false,
      duplicates: false
    }
  },
  components: { CreateTaskCanvas, PhotosModal, Popup , TasksFilterNav },

  mounted () {
    this.setDatePicker();
    this.task.responsibleuser = this.authUser.pduserid || localStorage.user_id
  },
  filters: {
    date :( val ) => formatDate(val),
  },
  created () {
    this.$store.commit('refreshNewTaskDetails');
    this.$store.dispatch("getProjectUsers",this.$route.params.id);
    this.$store.dispatch("getTaskDetailsById",[0 , this.$route.params.id] );
    this.$store.dispatch("getProjectServicesWithCompany",this.$route.params.id);
    this.$store.commit('setTaskEditPhotos', [])
    this.$store.commit('setTaskTempPhotos', [])
  },
  computed: {
    ...mapState({
      services: state => state.tasks.servicesWithCompanies,
      task: state => state.tasks.newTaskDetails,
      flags: state => state.tasks.newTaskDetails.pdflawflags,
      projectUsers: state => state.appSettings.projectUsers,
      photos: state => state.tasks.taskEditPhotos,
      plan: state => state.tasks.taskPlanImage,
      authUser: state => state.projects.user,
      allPlans: state => state.plans.allPlans,
      is_loading: state => state.constructionDiary.is_loading
    }),


    selectedTrades: {
      get(){
        return this.task.selectedtrades
      },
      set(val){
        this.$store.commit('setNewTaskDetailsServices',val)
      }
    },

    detailsPage: {
      get(){
        return this.$store.state.tasks.detailsPage
      },set(val){
        this.$store.commit('toggleTasksDetails',val)
      }
    },

    isEdit: {
      get(){
        return this.$store.state.tasks.isEdit
      },set(val){
        this.$store.commit('setTasksIsEdit',val)
      }
    },
  },
  methods: {
    setDatePicker () {
      let _this = this
      $('.datepicker').datepicker({
        autoclose: true,
        todayHighlight: true,
      }).on('changeDate', function(ev){
        let attr = ev.target.getAttribute('id');
        if (attr === 'frist'){
          _this.task.fristdate = formatAsInputDate(ev.target.value);
        }else if (attr === 'done') {
          _this.task.donedate = formatAsInputDate(ev.target.value);
        } else if (attr === 'notifi') {
          _this.task.notifiedate = formatAsInputDate(ev.target.value);
        } else if (attr === 'notice') {
        _this.task.noticedate = formatAsInputDate(ev.target.value);
       }
      })
    },

    /**Method To Save New Task API CALL
     *
     * @returns {Promise<void>}
     */
    async createTask () {
      if (this.duplicates){
        this.duplicates = !!document.querySelector("#task-params-create .is-invalid")
      }
      if (!this.duplicates){
        this.$store.commit('loading',true)
        const task = JSON.parse(JSON.stringify(this.task));
        task.flawitems = [];
        this.photos.forEach(photo => {
          const flawItem = {
            _explicitType: "com\\\\projectdocu\\\\PDFlawItemVO",
            pdflawid: 0,
            pdphotoid: photo.pdphotoid,
            pdflawitemid: 0,
            pdphototext: photo.description
          }
          task.flawitems.push(flawItem);
        });
        task.pdprojectid = this.$route.params.id
        task.pduserid = this.authUser.pduserid
        task.flawurl = `/backend/get?method=flaw&fid=${task.pdflawid}`
        task.selectedtrades.forEach(item => {
          item.pdserviceid = item.pdserviceid.replace('null','0')
        });
        task.defaultflawparams = []
        await this.$store.dispatch('updateTaskDetails',task)

        // await this.$store.dispatch('getTaskDetailsById', task.pdflawid);
        // if (task.pdflawflags.length && task.pdflawflags[0]) {
        //   await this.$store.dispatch('getTaskPlanImage', task.pdflawflags[0]);
        // }
        // await this.$store.dispatch('getImagesByIdsTasksModule', this.taskPhotosParams(task.flawitems))
        this.$store.commit('loading',false);
        this.$store.commit('refreshNewTaskDetails');

        await this.$router.push({name: 'tasksList', params: {id: this.$route.params.id}})
      }else {
         this.$toast.error("Bitte lösen Sie doppelte zusätzliche Felder auf")
      }
    },

    user(id) {
      return this.projectUsers.find(item => id === item.pduserid)
    },

    checkDuplicates(event){
      const value = event.target.value.toLowerCase()
      this.duplicates = this.task.flawparams.filter(item => item.paramtitle.toLowerCase() === value).length === 2;
      if (this.duplicates){
        event.target.classList.add('is-invalid')
      }else {
        event.target.classList.remove('is-invalid')
      }
    },

    setDate: (date) => formatDate(date),

    noticeDate(n_date){
      if (typeof n_date === 'string') {
        n_date = new Date(n_date);
      }

      if (isNaN(n_date.getTime())) {
        return '';
      }


      let day = n_date.getDate()
      let month = n_date.getMonth() + 1
      day = day < 10 ? `0${day}` : day
      month = month < 10  ? `0${month}`: month
      return `${day}.${month}.${n_date.getFullYear()}`
    },

    getUser(id){
      this.projectUsers.find(user => user.pduserid === id)
    },
    autoGrow(element) {
      element.style.height = "5px";
      element.style.height = (element.scrollHeight)+"px";
    },

    getService (service_id) {
      const id = service_id.split('-');
      return this.services.find(item => item.pdserviceid === parseInt(id[0]))
    },

    addNewFlawParam () {
      const param = {
        "pduserid": 0,
        "pdflawid": 0,
        "status": 0,
        "created": null,
        "paramtitle": "",
        "_explicitType": "com\\projectdocu\\PDFlawParamsVO",
        "paramvalue": "",
        "pdflawitemid": 0,
        "isNew": 'yes',
        "projectid": this.$route.params.id,
        "creator": 0
      }
      this.task.flawparams.push(param)
    },

    removeFlawParam(index){
      this.task.flawparams.splice(index, 1)
    },
    removePhoto(index) {
      this.$store.commit('removeTaskEditPhotos',index);
    }
  }
}

</script>
<style scoped>
img.delete-img{
  position: absolute;
  right: 4px;
  margin-top: 2px;
  display: none;
  cursor: pointer;
}
.params-div:hover .delete-img{
  display: block;
}
.canvas-box.screen-height{
  height: calc(100vh - 250px) !important;
  width: 92% !important;
  overflow-x: hidden;
}
input.service-checkbox{
  vertical-align: middle;
}
.doku-btns-sticky{
  bottom: 1px;
  z-index: 100;
  position: absolute;
  width: 81%;
  text-align: center;
  background: #ffffff7a;
  border-top: 1px solid grey;
}
.form-control.plan-select{
  height: 2rem;
  padding: 2px 7px;
  font-weight: bold;
}
.doku-btns-sticky button{
  font-size: 14px;
  font-weight: normal !important;
  padding: 4px 18px;
  line-height: inherit;
}
.scroll-services{
  max-height: 15.5rem;
  overflow-x: hidden;
  overflow-y:auto ;
}
.create-height.screen-height{
  height: calc(100vh - 103px) !important;
}
.scroll-services::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .6);
  background-color: #3399ff9e;
  opacity: 1;
}
.scroll-services::-webkit-scrollbar {
  width: 6px;
  background-color: #bebaba;
}
.mt--10{
  margin-top: -7px;
}
.zoom-box{
  top: 3px;
  left: 5px;
  z-index: 99999;
}
.btn-light:hover{
  color: white !important;
  background: #2c6ed5;
}
.simple-photo .remove-img{
  width: 19px;
  z-index: 99;
  cursor: pointer;
  visibility: hidden;
  top: 4px;
  left: 4px;
}
.simple-photo:hover .remove-img{
  visibility: visible;
}
textarea {
  resize: none;
  overflow: hidden;
  min-height: 50px;
  max-height: 150px;
}
</style>



// WEBPACK FOOTER //
// src/components/tasks/CreateTask.vue